import styled from 'styled-components'

// Components
import BaseSpinner from 'components/Spinner'

export const Spinner = styled(BaseSpinner).attrs({
  primary: true,
})`
  margin: 40px auto;
  display: block;
`
